import {
  crsOptions,
  type Enterprise,
  type UserEnterprise,
} from '@pn/core/domain/enterprise';
import { nullToUndefined, undefinedToNull } from '@pn/core/utils/logic';
import { apiUserMapper } from '@pn/services/api/user/apiUserMapper';
import type { ApiEnterprise, ApiUserEnterprise } from './types';

export const apiEnterpriseMapper = {
  toDomainEnterprise: (apiEnterprise: ApiEnterprise): Enterprise => {
    return {
      id: apiEnterprise.id,
      createdAt: apiEnterprise.created_at,
      name: apiEnterprise.name,
      logoUrl: apiEnterprise.logo,
      crs: apiEnterprise.crs ?? crsOptions[0],
      authTenantId: nullToUndefined(apiEnterprise.auth_tenant_id),
      authenticationTypes: apiEnterprise.auth_connections,
      stackCompanyId: nullToUndefined(apiEnterprise.stack_company_id),
      stackCompanies: apiEnterprise.stack_companies?.map((company) => ({
        name: company.name,
        stackCompanyId: company.stack_company_id,
      })),
      stackLayers: apiEnterprise.stack_layers,
      users: apiEnterprise.users.map(apiUserMapper.toDomainUser), // empty for admin panel, but populated for enterprise admin page on maps
      hasStackGPT: apiEnterprise.has_stack_gpt ?? false,
      productsEnabled: {
        maps: apiEnterprise.enabled_products?.includes('maps') ?? false,
        intel: apiEnterprise.enabled_products?.includes('intel') ?? false,
      },
    };
  },
  toTargetEnterprise: (enterprise: Enterprise): ApiEnterprise => {
    return {
      id: enterprise.id,
      name: enterprise.name,
      logo: enterprise.logoUrl,
      created_at: enterprise.createdAt,
      crs: enterprise.crs,
      auth_tenant_id: undefinedToNull(enterprise.authTenantId),
      auth_connections: enterprise.authenticationTypes,
      stack_company_id: undefinedToNull(enterprise.stackCompanyId),
      stack_companies: enterprise.stackCompanies.map((company) => ({
        name: company.name,
        stack_company_id: company.stackCompanyId,
      })),
      stack_layers: {}, // not used
      users: [], // not used
      has_stack_gpt: enterprise.hasStackGPT,
      enabled_products: [
        ...(enterprise.productsEnabled.maps ? ['maps'] : []),
        ...(enterprise.productsEnabled.intel ? ['intel'] : []),
      ],
    };
  },
};

export const apiUserEnterpriseMapper = {
  toDomainUserEnterprise: (
    apiUserEnterprise: ApiUserEnterprise
  ): UserEnterprise => {
    return {
      id: apiUserEnterprise.id,
      name: apiUserEnterprise.name,
      stackCompanyId: nullToUndefined(apiUserEnterprise.stack_company_id),
      stackCompanies: apiUserEnterprise.stack_companies.map((company) => ({
        name: company.name,
        stackCompanyId: company.stack_company_id,
      })),
      stackLayers: apiUserEnterprise.stack_layers,
    };
  },
};
